import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { AppContext } from '../control/context';

@Component({
  selector: 'i-caption',
  templateUrl: './caption.component.html',
  styleUrls: ['./caption.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CaptionComponent implements OnInit {
  @Input() i18n_name: string;

  caption: string;

  constructor(private appContext: AppContext) {}

  ngOnInit() {
    this.caption = this.appContext.getI18NString(this.i18n_name);
  }
}
